import { useState, useEffect } from 'react';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <a
      href="#"
      className="btn btn-lg btn-primary btn-lg-square back-to-top"
      onClick={scrollToTop}
      style={{ display: visible ? 'block' : 'none' }}
    >
      <i className="bi bi-arrow-up"></i>
    </a>
  );
}

export default BackToTop;
